/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { MatchLobbyTeamResponse } from './MatchLobbyTeamResponse';
import {
    MatchLobbyTeamResponseFromJSON,
    MatchLobbyTeamResponseFromJSONTyped,
    MatchLobbyTeamResponseToJSON,
    MatchLobbyTeamResponseToJSONTyped,
} from './MatchLobbyTeamResponse';
import type { LobbyInstructionsTemplateResponse } from './LobbyInstructionsTemplateResponse';
import {
    LobbyInstructionsTemplateResponseFromJSON,
    LobbyInstructionsTemplateResponseFromJSONTyped,
    LobbyInstructionsTemplateResponseToJSON,
    LobbyInstructionsTemplateResponseToJSONTyped,
} from './LobbyInstructionsTemplateResponse';
import type { CompetitionMatchStatus } from './CompetitionMatchStatus';
import {
    CompetitionMatchStatusFromJSON,
    CompetitionMatchStatusFromJSONTyped,
    CompetitionMatchStatusToJSON,
    CompetitionMatchStatusToJSONTyped,
} from './CompetitionMatchStatus';
import type { MatchLiveScoreResponse } from './MatchLiveScoreResponse';
import {
    MatchLiveScoreResponseFromJSON,
    MatchLiveScoreResponseFromJSONTyped,
    MatchLiveScoreResponseToJSON,
    MatchLiveScoreResponseToJSONTyped,
} from './MatchLiveScoreResponse';

/**
 * 
 * @export
 * @interface MatchLobbyResponse
 */
export interface MatchLobbyResponse {
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    matchId: string;
    /**
     * The tournament this match belongs to, so the match page can name it instead of showing a generic label.
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    tournamentName?: string;
    /**
     * 
     * @type {CompetitionMatchStatus}
     * @memberof MatchLobbyResponse
     */
    status: CompetitionMatchStatus;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    region?: string;
    /**
     * Whether the caller is a roster member of one of the two teams (gates lobby credentials).
     * @type {boolean}
     * @memberof MatchLobbyResponse
     */
    viewerIsParticipant: boolean;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    viewerTeamId?: string;
    /**
     * 
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    hostTeamId?: string;
    /**
     * Generated server/lobby name. Returned only to match participants.
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    lobbyName?: string;
    /**
     * Generated lobby password. Returned only to match participants.
     * @type {string}
     * @memberof MatchLobbyResponse
     */
    lobbyPassword?: string;
    /**
     * 
     * @type {LobbyInstructionsTemplateResponse}
     * @memberof MatchLobbyResponse
     */
    template?: LobbyInstructionsTemplateResponse;
    /**
     * 
     * @type {Array<MatchLobbyTeamResponse>}
     * @memberof MatchLobbyResponse
     */
    teams: Array<MatchLobbyTeamResponse>;
    /**
     * 
     * @type {MatchLiveScoreResponse}
     * @memberof MatchLobbyResponse
     */
    liveScore?: MatchLiveScoreResponse;
    /**
     * Whether score submission is currently allowed for this match (anti-snipe gate — Match End telemetry, elapsed floor, or timed-window expiry).
     * @type {boolean}
     * @memberof MatchLobbyResponse
     */
    scoringOpen?: boolean;
    /**
     * Epoch ms when the elapsed-floor fallback opens submission. Absent when scoring is already open or no floor is configured.
     * @type {number}
     * @memberof MatchLobbyResponse
     */
    scoringOpensAt?: number;
    /**
     * Minutes an unanswered game-verified score waits before auto-confirming. From TournamentTimerConfig — the web must not hardcode a copy.
     * @type {number}
     * @memberof MatchLobbyResponse
     */
    verifiedScoreConfirmMinutes?: number;
    /**
     * Minutes an unanswered manual claim waits before auto-confirming.
     * @type {number}
     * @memberof MatchLobbyResponse
     */
    manualScoreConfirmMinutes?: number;
}



/**
 * Check if a given object implements the MatchLobbyResponse interface.
 */
export function instanceOfMatchLobbyResponse(value: object): value is MatchLobbyResponse {
    if (!('matchId' in value) || value['matchId'] === undefined) return false;
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('viewerIsParticipant' in value) || value['viewerIsParticipant'] === undefined) return false;
    if (!('teams' in value) || value['teams'] === undefined) return false;
    return true;
}

export function MatchLobbyResponseFromJSON(json: any): MatchLobbyResponse {
    return MatchLobbyResponseFromJSONTyped(json, false);
}

export function MatchLobbyResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): MatchLobbyResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'matchId': json['matchId'],
        'tournamentName': json['tournamentName'] == null ? undefined : json['tournamentName'],
        'status': CompetitionMatchStatusFromJSON(json['status']),
        'region': json['region'] == null ? undefined : json['region'],
        'viewerIsParticipant': json['viewerIsParticipant'],
        'viewerTeamId': json['viewerTeamId'] == null ? undefined : json['viewerTeamId'],
        'hostTeamId': json['hostTeamId'] == null ? undefined : json['hostTeamId'],
        'lobbyName': json['lobbyName'] == null ? undefined : json['lobbyName'],
        'lobbyPassword': json['lobbyPassword'] == null ? undefined : json['lobbyPassword'],
        'template': json['template'] == null ? undefined : LobbyInstructionsTemplateResponseFromJSON(json['template']),
        'teams': ((json['teams'] as Array<any>).map(MatchLobbyTeamResponseFromJSON)),
        'liveScore': json['liveScore'] == null ? undefined : MatchLiveScoreResponseFromJSON(json['liveScore']),
        'scoringOpen': json['scoringOpen'] == null ? undefined : json['scoringOpen'],
        'scoringOpensAt': json['scoringOpensAt'] == null ? undefined : json['scoringOpensAt'],
        'verifiedScoreConfirmMinutes': json['verifiedScoreConfirmMinutes'] == null ? undefined : json['verifiedScoreConfirmMinutes'],
        'manualScoreConfirmMinutes': json['manualScoreConfirmMinutes'] == null ? undefined : json['manualScoreConfirmMinutes'],
    };
}

export function MatchLobbyResponseToJSON(json: any): MatchLobbyResponse {
    return MatchLobbyResponseToJSONTyped(json, false);
}

export function MatchLobbyResponseToJSONTyped(value?: MatchLobbyResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'matchId': value['matchId'],
        'tournamentName': value['tournamentName'],
        'status': CompetitionMatchStatusToJSON(value['status']),
        'region': value['region'],
        'viewerIsParticipant': value['viewerIsParticipant'],
        'viewerTeamId': value['viewerTeamId'],
        'hostTeamId': value['hostTeamId'],
        'lobbyName': value['lobbyName'],
        'lobbyPassword': value['lobbyPassword'],
        'template': LobbyInstructionsTemplateResponseToJSON(value['template']),
        'teams': ((value['teams'] as Array<any>).map(MatchLobbyTeamResponseToJSON)),
        'liveScore': MatchLiveScoreResponseToJSON(value['liveScore']),
        'scoringOpen': value['scoringOpen'],
        'scoringOpensAt': value['scoringOpensAt'],
        'verifiedScoreConfirmMinutes': value['verifiedScoreConfirmMinutes'],
        'manualScoreConfirmMinutes': value['manualScoreConfirmMinutes'],
    };
}

